import { create } from 'zustand';

export const enum OverlayTypes {
	CONTENT = 'CONTENT',
	FULL = 'FULL',
}

interface OverlayStoreProps {
	showOverlay: OverlayTypes | false;
	setShowOverlay: (showOverlay: OverlayTypes | false) => void;
}

export const useOverlayStore = create<OverlayStoreProps>((set) => ({
	showOverlay: false,
	setShowOverlay: (showOverlay): void => {
		set({ showOverlay });
	},
}));
